import styled from "styled-components";
import { colors } from "../../../../../theme/theme";

export const CreateSubscriptionWrapper = styled.div`
	padding: 8px 8px 40px;

	.user-dropdown .p-dropdown-label {
		padding: 10px;
	}

	.docs {
		margin-left: 0;
		min-height: 36px;

		border: 1px solid rgb(207, 207, 207);
		border-radius: 4px;

		padding: 2px 8px;
	}

	.subscriber-name {
		font-size: 14px;
		font-weight: 400;
		color: ${colors.greyscale.darker_grey};
	}
`;
